import React from "react";
import { MapPin, Phone, MessageCircle } from "lucide-react";
import { COMPANY, NEIGHBORHOODS, waLink, telLink } from "../lib/contact";

export const SeoLocations = () => {
  return (
    <section
      id="atendimento"
      data-testid="seo-locations-section"
      className="relative py-16 md:py-24 bg-[#027ec3] text-white overflow-hidden"
    >
      {/* Decorative background lines */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-10 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)",
          backgroundSize: "56px 56px",
        }}
      />
      <div className="absolute -top-20 -left-20 w-96 h-96 bg-[#fff505] rounded-full blur-3xl opacity-25" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#fff505] text-[#0f172a] text-xs font-extrabold uppercase tracking-[0.2em] mb-4 border-2 border-[#0f172a]">
            <MapPin className="w-3.5 h-3.5" strokeWidth={3} /> Cobertura local
          </div>
          <h2
            data-testid="seo-locations-title"
            className="font-display text-4xl sm:text-5xl md:text-6xl text-white max-w-4xl mx-auto"
          >
            Aluguel de caçambas em{" "}
            <span className="bg-[#fff505] text-[#0f172a] px-2">Jundiaí</span>
          </h2>
          <p className="mt-5 text-white/80 font-medium max-w-2xl mx-auto text-base md:text-lg">
            Atendimento rápido para obras, reformas e remoção de entulho.
            Confira os bairros de Jundiaí que atendemos.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          {/* Bairros */}
          <div className="bg-white text-[#0f172a] border-2 border-[#0f172a] p-6 md:p-10">
            <h3 className="font-display text-2xl md:text-4xl mb-1">
              Bairros atendidos em <span className="text-[#027ec3]">Jundiaí</span>
            </h3>
            <p className="text-sm font-semibold uppercase tracking-wider text-[#475569]">
              {NEIGHBORHOODS.length} bairros e crescendo
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {NEIGHBORHOODS.map((b, i) => (
                <a
                  key={b}
                  href={waLink(`Olá! Vocês atendem o bairro ${b} em Jundiaí? Preciso de uma caçamba.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`neighborhood-${i}`}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 border-2 border-[#0f172a] bg-white hover:bg-[#fff505] text-[#0f172a] text-sm font-bold transition-colors"
                >
                  <MapPin className="w-3.5 h-3.5" strokeWidth={3} />
                  {b}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Big CTA panel */}
        <div className="mt-12 bg-[#fff505] border-2 border-[#0f172a] p-6 md:p-10 grid md:grid-cols-12 gap-6 items-center shadow-[12px_12px_0_#0f172a]">
          <div className="md:col-span-7 text-[#0f172a]">
            <h3 className="font-display text-3xl sm:text-4xl md:text-5xl">
              Sua obra não pode esperar.
              <br />
              <span className="text-[#027ec3]">Chame no WhatsApp agora.</span>
            </h3>
            <p className="mt-3 font-bold text-[#0f172a]/80">
              Atendimento imediato · Preço justo · Entrega rápida em {COMPANY.region}
            </p>
          </div>
          <div className="md:col-span-5 flex flex-col gap-3">
            <a
              href={waLink("Olá! Preciso de caçamba urgente. Pode me ajudar?")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="seo-whatsapp-btn"
              className="inline-flex items-center justify-center gap-3 px-6 py-5 bg-[#25d366] text-white font-extrabold uppercase tracking-wide border-2 border-[#0f172a] shadow-[6px_6px_0_#0f172a] hover:shadow-[10px_10px_0_#0f172a] hover:-translate-x-[3px] hover:-translate-y-[3px] transition-all text-lg"
            >
              <MessageCircle className="w-6 h-6" strokeWidth={2.5} />
              Chamar no WhatsApp
            </a>
            <a
              href={telLink}
              data-testid="seo-phone-btn"
              className="inline-flex items-center justify-center gap-3 px-6 py-5 bg-[#0f172a] text-white font-extrabold uppercase tracking-wide border-2 border-[#0f172a] hover:bg-[#027ec3] transition-colors text-lg"
            >
              <Phone className="w-6 h-6" strokeWidth={2.5} />
              {COMPANY.phoneDisplay}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SeoLocations;
